import { useEffect, useRef } from 'react'
import { useSnackbar } from 'notistack'

import { AppEvents } from 'src/constants'

interface IErrorWrapperProps {
  children: React.ReactNode
}

const ErrorWrapper = ({ children }: IErrorWrapperProps) => {
  const { enqueueSnackbar } = useSnackbar()
  const lastSnackbarTimeRef = useRef<number>(0)

  useEffect(() => {
    document.addEventListener(AppEvents.HTTP_SUCCESS, listenSuccess)
    document.addEventListener(AppEvents.HTTP_WARNING, listenWarn)
    document.addEventListener(AppEvents.HTTP_ERROR, listenError)

    return () => {
      document.removeEventListener(AppEvents.HTTP_SUCCESS, listenSuccess)
      document.removeEventListener(AppEvents.HTTP_WARNING, listenWarn)
      document.removeEventListener(AppEvents.HTTP_ERROR, listenError)
    }

    function listenSuccess(success: any) {
      processEvent(success, 'success')
    }

    function listenWarn(warning: any) {
      processEvent(warning, 'warning')
    }

    function listenError(error: any) {
      if (error.detail?.statusCode === 429) {
        return
      }

      processEvent(error, 'error')
    }

    function processEvent(event: any, variant: 'success' | 'warning' | 'error') {
      const currentTime = Date.now()
      if (currentTime - lastSnackbarTimeRef.current > 2000) {
        lastSnackbarTimeRef.current = currentTime
        if (event?.detail?.message) {
          enqueueSnackbar(event.detail.message, { variant, autoHideDuration: 3000 })
        }
      }
    }
  }, [enqueueSnackbar])

  return <>{children}</>
}

export { ErrorWrapper }
